// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.goal_modal_backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.goal_modal {
    background: white;
    border-radius: 12px;
    width: 90%;
    max-width: 480px;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.goal_modal_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 24px 16px;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
}

.goal_modal_title {
    font-size: calc(20px * var(--fontScaler));
    font-weight: 600;
    color: #1D1D1F;
    margin: 0;
}

.goal_modal_close {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    border: none;
    background: transparent;
    color: #1D1D1F;
    font-size: 28px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease;
    padding: 0;
}

.goal_modal_close:hover {
    background: rgba(0, 0, 0, 0.05);
}

.goal_modal_form {
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.goal_modal_field {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.goal_modal_label {
    font-size: calc(13px * var(--fontScaler));
    font-weight: 500;
    color: #1D1D1F;
}

.goal_modal_input {
    padding: 10px 14px;
    border: 0.5px solid rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    font-size: calc(15px * var(--fontScaler));
    font-weight: 400;
    color: #1D1D1F;
    background: #F9F9FB;
    transition: border-color 0.2s ease;
}

.goal_modal_input:focus {
    outline: none;
    border-color: #007AFF;
}

.goal_modal_emoji_input {
    position: relative;
}

.goal_modal_emoji_button {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    border: 0.5px solid rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    background: #F9F9FB;
    cursor: pointer;
    width: 100%;
    transition: border-color 0.2s ease;
}

.goal_modal_emoji_button:hover {
    border-color: #007AFF;
}

.goal_modal_emoji_preview {
    font-size: calc(28px * var(--fontScaler));
    line-height: 1;
}

.goal_modal_emoji_text {
    font-size: calc(15px * var(--fontScaler));
    font-weight: 400;
    color: #86868B;
}

.goal_modal_emoji_picker {
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    z-index: 10;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
    border-radius: 12px;
    overflow: hidden;
}

.goal_modal_actions {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    margin-top: 8px;
}

.goal_modal_cancel,
.goal_modal_save {
    padding: 10px 24px;
    border-radius: 8px;
    border: none;
    font-size: calc(15px * var(--fontScaler));
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.goal_modal_cancel {
    background: transparent;
    color: #1D1D1F;
}

.goal_modal_cancel:hover {
    background: rgba(0, 0, 0, 0.05);
}

.goal_modal_save {
    background: #007AFF;
    color: white;
}

.goal_modal_save:hover {
    background: #0051D5;
}

/* Scrollbar styling for modal */
.goal_modal::-webkit-scrollbar {
    width: 8px;
}

.goal_modal::-webkit-scrollbar-track {
    background: transparent;
}

.goal_modal::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 6px;
}

.goal_modal::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/goalsWidget/GoalModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,6CAA6C;AACjD;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,UAAU;AACd;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,sCAAsC;IACtC,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,WAAW;IACX,yCAAyC;IACzC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,yBAAyB;IACzB,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,yCAAyC;IACzC,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,gCAAgC;AAChC;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":[".goal_modal_backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.goal_modal {\n    background: white;\n    border-radius: 12px;\n    width: 90%;\n    max-width: 480px;\n    max-height: 90vh;\n    overflow-y: auto;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.goal_modal_header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 24px 24px 16px;\n    border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);\n}\n\n.goal_modal_title {\n    font-size: calc(20px * var(--fontScaler));\n    font-weight: 600;\n    color: #1D1D1F;\n    margin: 0;\n}\n\n.goal_modal_close {\n    width: 32px;\n    height: 32px;\n    border-radius: 6px;\n    border: none;\n    background: transparent;\n    color: #1D1D1F;\n    font-size: 28px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.2s ease;\n    padding: 0;\n}\n\n.goal_modal_close:hover {\n    background: rgba(0, 0, 0, 0.05);\n}\n\n.goal_modal_form {\n    padding: 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.goal_modal_field {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.goal_modal_label {\n    font-size: calc(13px * var(--fontScaler));\n    font-weight: 500;\n    color: #1D1D1F;\n}\n\n.goal_modal_input {\n    padding: 10px 14px;\n    border: 0.5px solid rgba(0, 0, 0, 0.2);\n    border-radius: 8px;\n    font-size: calc(15px * var(--fontScaler));\n    font-weight: 400;\n    color: #1D1D1F;\n    background: #F9F9FB;\n    transition: border-color 0.2s ease;\n}\n\n.goal_modal_input:focus {\n    outline: none;\n    border-color: #007AFF;\n}\n\n.goal_modal_emoji_input {\n    position: relative;\n}\n\n.goal_modal_emoji_button {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 14px;\n    border: 0.5px solid rgba(0, 0, 0, 0.2);\n    border-radius: 8px;\n    background: #F9F9FB;\n    cursor: pointer;\n    width: 100%;\n    transition: border-color 0.2s ease;\n}\n\n.goal_modal_emoji_button:hover {\n    border-color: #007AFF;\n}\n\n.goal_modal_emoji_preview {\n    font-size: calc(28px * var(--fontScaler));\n    line-height: 1;\n}\n\n.goal_modal_emoji_text {\n    font-size: calc(15px * var(--fontScaler));\n    font-weight: 400;\n    color: #86868B;\n}\n\n.goal_modal_emoji_picker {\n    position: absolute;\n    top: calc(100% + 8px);\n    left: 0;\n    z-index: 10;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n    border-radius: 12px;\n    overflow: hidden;\n}\n\n.goal_modal_actions {\n    display: flex;\n    gap: 12px;\n    justify-content: flex-end;\n    margin-top: 8px;\n}\n\n.goal_modal_cancel,\n.goal_modal_save {\n    padding: 10px 24px;\n    border-radius: 8px;\n    border: none;\n    font-size: calc(15px * var(--fontScaler));\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.goal_modal_cancel {\n    background: transparent;\n    color: #1D1D1F;\n}\n\n.goal_modal_cancel:hover {\n    background: rgba(0, 0, 0, 0.05);\n}\n\n.goal_modal_save {\n    background: #007AFF;\n    color: white;\n}\n\n.goal_modal_save:hover {\n    background: #0051D5;\n}\n\n/* Scrollbar styling for modal */\n.goal_modal::-webkit-scrollbar {\n    width: 8px;\n}\n\n.goal_modal::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.goal_modal::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 6px;\n}\n\n.goal_modal::-webkit-scrollbar-thumb:hover {\n    background: rgba(0, 0, 0, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
